import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PlannerViewsStateService } from '../../../../services/planner-views-state.service';
import { CustomRouteMobileViewsStateService } from 'src/app/pages/custom-route/components/custom-route-mobile/services/custom-route-mobile-views-state.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../../../../../../components/custom-route-mobile/config/constants';
import { StepsNavigationMapService } from 'src/app/pages/custom-route/shared/map/services/steps-navigation.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { ActionsButtonsExpandedComponent } from "./components/actions-buttons-expanded/actions-buttons-expanded.component";
import { ActionsButtonsCompactComponent } from "./components/actions-buttons-compact/actions-buttons-compact.component";
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { BottomSheetConfig, BottomSheetData } from 'src/app/interfaces/mat.interface';
import { MakePaymentComponent } from '../../../buy-tickets/components/make-payment/make-payment.component';


@Component({
  selector: 'app-action-buttons',
  standalone: true,
  imports: [TranslateModule, ActionsButtonsExpandedComponent, ActionsButtonsCompactComponent],
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActionButtonsComponent {
  private _stepsNavigationService = inject(StepsNavigationMapService);
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  private _customRouteMobileViewsStateService = inject(CustomRouteMobileViewsStateService);
  private _scrollService = inject(ScrollService);
  private _breakpointsService = inject(BreakpointsService);
  private _matBottomSheetService = inject(MatBottomSheetService);
  
  private _isMobile = this._breakpointsService.isMobile;
  private _isScrolled = this._scrollService.isScrolled;
  private _isEditRouteView = this._plannerViewsStateService.isEditRouteView;
  //private readonly _isBuyTicketsView = computed(() => this._plannerViewsStateService.isBuyTicketsView());

  public isActionButtonsCompactSignal = computed(() => this._isMobile() && this._isScrolled());

  public handleStartRouteClick() {
    this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.map);
    // TODO: Implement the logic to start the route
    setTimeout(() => {
        this._stepsNavigationService.startRoute()
    }, 150);  
  }
  
  public handleEditRouteClick() {
    const newIsEditRouteView = !this._isEditRouteView();
    this._plannerViewsStateService.isEditRouteView.set(newIsEditRouteView);
  }
  
  public async handleBuyTicketsClick() {
    // TODO: NO BORRO ESTO PARA NO OLVIDAR DE COMO MOSTRAR BUYTICKET VIEW PARA EL IFRAME
    //const newIsBuyTicketsView = !this._isBuyTicketsView();
    //this._plannerViewsStateService.isBuyTicketsView.set(newIsBuyTicketsView);
    await this._openMakePaymentBottomSheet();
  }
  
  private async _openMakePaymentBottomSheet() {
    const bottomSheetConfig: BottomSheetConfig<MakePaymentComponent, BottomSheetData> = {
      component: MakePaymentComponent,
      panelClass: this._isMobile() ? 'make-payment-bottom-sheet--mobile' : 'make-payment-bottom-sheet--desktop',
    }    
    
    await this._matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
  }
}
